<div [formGroup]="dataForm" class="aside-content aside-width-6">
  <div class="aside-header fx-layout-row fx-layout-align-space-between-m fx-layout-align-center-x">
    <h3>{{ saveText }} Note</h3>
    <div class="fx-layout-row fx-gap-10">
      <button mat-raised-button (click)="save()" color="primary">{{ saveText }}</button>
      <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
  </div>
  <concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
  <div>
    <div>
      <mat-form-field>
        <mat-label>Description</mat-label>
        <textarea formControlName="description" matInput matTextareaAutosize matAutosizeMinRows="3"></textarea>
      </mat-form-field>
      @if (description.touched && description.errors?.required) {
        <mat-error>
          Description is required
        </mat-error>
      }
      @if (description.touched && description.errors?.maxlength) {
        <mat-error>
          Description must be no more than 200 characters
        </mat-error>
      }
    </div>

    <div>
      <mat-form-field>
        <mat-label>Content</mat-label>
        <textarea formControlName="content" matInput matTextareaAutosize matAutosizeMinRows="5"></textarea>
      </mat-form-field>
      @if (content.touched && content.errors?.required) {
        <mat-error>
          Content is required
        </mat-error>
      }
    </div>
  </div>
</div>